<template>
  <b-form-checkbox
    v-bind:checked="value"
    v-bind:indeterminate="indeterminate"
    class="custom-check"
    v-on:change="onChange"
  />
</template>

<script>
/**
 * ag-grid の header(全件チェックボックス) に BFormCheckbox を描画するレンダラー
 */
export default {
  name: 'AppBFormCheckboxHeaderRenderer',
  data: function () {
    return {
      /**
       * 選択状態
       * @type {boolean}
       */
      value: false,
      /**
       * 中間状態
       * @type {boolean}
       */
      indeterminate: false,
    }
  },
  computed: {
    /**
     * gridApi
     * @type {GridApi}
     */
    gridApi: function () {
      return this.params.api
    },
  },
  created: function () {
    // 初期状態を反映
    this.onSelectionChange()
  },
  mounted: function () {
    this.gridApi.addEventListener('selectionChanged', this.onSelectionChange)
  },
  beforeDestroy: function () {
    this.gridApi.removeEventListener('selectionChanged', this.onSelectionChange)
  },
  methods: {
    /**
     * チェックボックスの change イベントコールバック
     */
    onChange(v) {
      v ? this.gridApi.selectAll() : this.gridApi.deselectAll()
    },
    /**
     * ag-grid の selectionChanged イベントコールバック
     */
    onSelectionChange() {
      let nodeCount = 0
      let selectedCount = 0
      this.gridApi.forEachNode((node) => {
        nodeCount += 1
        if (node.isSelected()) {
          selectedCount += 1
        }
      })
      this.value = selectedCount > 0 && selectedCount === nodeCount
      this.indeterminate = selectedCount < nodeCount && selectedCount > 0
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-check {
  padding-left: 1rem;
  min-height: 1rem;
  height: 1rem;

  ::v-deep .custom-control-input {
    height: 1rem;
  }

  ::v-deep .custom-control-label {
    &::before {
      top: 0;
      left: -1rem;
    }
    &::after {
      top: 0;
      left: -1rem;
    }
  }
}
</style>
